import { Controller } from "@hotwired/stimulus"
import WaveSurfer from "wavesurfer.js"

export default class extends Controller {
  static values = { url: String }
  static targets = ["container", "fallback", "button"]

  connect() {
    this.boundSeekWave = this.seekWave.bind(this)
    this.initWave();
  }

  initWave() {
    if (this.wave) {
      this.wave.destroy();
    }

    this.wave = WaveSurfer.create({
      container: this.containerTarget,
      waveColor: "rgba(0, 255, 195, 0.7)",
      progressColor: "rgba(255, 105, 180, 0.9)",
      height: 80,
      responsive: true,
      normalize: true,
      backend: "MediaElement",
      interact: true,
    });

    this.wave.on("ready", () => {
      this.containerTarget.classList.remove("hidden");
      this.buttonTarget.classList.remove("hidden");
      this.fallbackTarget.classList.add("hidden");
      this.containerTarget.addEventListener("click", this.boundSeekWave);
    });

    this.wave.on("error", () => {
      this.showFallback();
    });

    this.wave.load(this.urlValue);
  }

  toggle() {
    if (this.wave) {
      this.wave.playPause();
    }
  }

  seekWave(event) {
    if (!this.wave) return;

    const bbox = this.containerTarget.getBoundingClientRect();
    const x = event.clientX - bbox.left;
    const percent = x / bbox.width;
    this.wave.seekTo(percent);
  }

  disconnect() {
    if (this.boundSeekWave && this.hasContainerTarget) {
      this.containerTarget.removeEventListener("click", this.boundSeekWave);
    }

    if (this.wave) {
      this.wave.destroy();
    }
  }

  showFallback() {
    if (this.hasContainerTarget) this.containerTarget.classList.add("hidden");
    if (this.hasButtonTarget) this.buttonTarget.classList.add("hidden");
    if (this.hasFallbackTarget) this.fallbackTarget.classList.remove("hidden");
  }
}
